import styled from 'styled-components'

interface ITabPanesStyledProps {}

export const TabPanesStyled = styled.div<ITabPanesStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
